/** Business details shown in header, footer and help links. */
export const siteInfo = {
  name: 'VerniciSubito',
  company: 'Colori Novellino',
  tagline: 'Il tuo laboratorio del colore online',
  phone: '0974 274152',
  phoneHref: 'tel:+390974274152',
  whatsapp: '320 025 8868',
  whatsappHref: 'https://wa.me/393200258868',
  email: 'info@vernicisubito.it',
  address: 'Via degli Ulivi, 4 · Agropoli (SA)',
  vat: 'P. IVA 05921100656',
  /**
   * Legal details required on the site (D.Lgs. 70/2003, art. 7), shown in the footer when set.
   * Still to be provided by the shop (open question 11): REA number and PEC.
   */
  rea: '',
  pec: '',
}

export const mailto = (subject: string, body?: string) =>
  `mailto:${siteInfo.email}?subject=${encodeURIComponent(subject)}${
    body ? `&body=${encodeURIComponent(body)}` : ''
  }`

/** Static guides copied from the prototype into `public/vernicisubito/documentazione/`. */
export const docUrl = (file: string) => `/vernicisubito/documentazione/${file}`
